import { type ReactNode, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { BreakpointsEnum } from 'shared/constants/breakpoints'
import { useSettingsContext } from 'pages/settings/context/settingsContext'
import styles from './styles.module.scss'

type IOverviewPageLayoutProps = {
  children?: ReactNode
}

export const OverviewPageLayout = observer(({ children }: IOverviewPageLayoutProps) => {
  const { pageLayoutStore } = useSettingsContext()

  useEffect(() => {
    pageLayoutStore.setCustomCollapseWidth(BreakpointsEnum.S)

    return () => {
      pageLayoutStore.setCustomCollapseWidth(null)
    }
  }, [pageLayoutStore])

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>{children ?? <Outlet />}</div>
      </div>
    </div>
  )
})
